module.exports = __webpack_public_path__ + "img/chris.0b9d3618.jpg";